import React, { Component } from 'react';
import { SpaceBetween, Tabs } from '@amzn/awsui-components-react-v3';
import { TagsTable } from './tagBasedAccess';
import { DATACONSUMER } from 'src/commons/constants';
import { ResourcesTable } from 'src/components/workspace_access/resourceBasedAccess';

interface MyRequestsProps {
  groupInfo: string | undefined;
  activeWorkspace: any;
  activeGroup: 'outgoingRequests' | 'incomingRequests';
  username: string | undefined;
  setContentType?: (contentType: string | undefined) => void;
  customerType: string;
}

export interface BrowseTableState {
  activeTabId: string | undefined;
}

export default class MyRequests extends Component<MyRequestsProps, BrowseTableState> {
  state = {
    // Consumers should default to outgoing requests
    activeTabId: this.props.customerType === DATACONSUMER ? 'outgoingRequests' : 'incomingRequests',
  };

  render() {
    const { setContentType, activeGroup, activeWorkspace } = this.props;

    let tabs = [
      {
        label: 'Incoming',
        id: 'incomingRequests',
        content: (
          <SpaceBetween size='l'>
            <TagsTable
              isIncomingRequests={true}
              setContentType={setContentType}
              activeGroup={activeGroup}
              activeWorkspace={activeWorkspace}
            />
            <ResourcesTable
              {...this.props}
              isIncomingRequests={true}
              setContentType={setContentType}
              activeGroup={activeGroup}
              activeWorkspace={activeWorkspace}
            />
          </SpaceBetween>
        ),
      },
      {
        label: 'Outgoing',
        id: 'outgoingRequests',
        content: (
          <SpaceBetween size='l'>
            <TagsTable
              {...this.props}
              isIncomingRequests={false}
              setContentType={setContentType}
              activeGroup={activeGroup}
              activeWorkspace={activeWorkspace}
            />
            <ResourcesTable
              {...this.props}
              isIncomingRequests={false}
              setContentType={setContentType}
              activeGroup={activeGroup}
              activeWorkspace={activeWorkspace}
            />
          </SpaceBetween>
        ),
      },
    ];

    if (this.props.customerType === DATACONSUMER) {
      tabs.reverse(); // We want outgoing to be first for consumers
    }

    return (
      <>
        <Tabs
          tabs={tabs}
          activeTabId={this.state.activeTabId}
          variant='default'
          onChange={({ detail }) => {
            this.setState({ activeTabId: detail.activeTabId });
          }}
        />
      </>
    );
  }
}
